<template>
  <section class="myhome-con"
           v-if="isInit">
    <div class="tit-box type1">
      <h1 class="tit-type1">정기결제 수단 관리</h1>
      <span class="info1">
        <span class="pc01">매월 이용료는 익월 15일에 결제됩니다.</span>(※주말 및 공휴일은 익영업일에 결제가 이루어집니다.)
      </span>
    </div>
    <div class="layer-cho-card" style="width:50%;">
      <div class="card-con">
        <div class="current">
          <div class="entry-tit">
            <i class="far fa-credit-card-front"></i> 카드빌링
          </div>
          <div class="entry-con" v-if="cardBlngDl.bcrtnoMngSn != null">
            <dl>
              <dt>{{ cardBlngDl.issuCdcoNm }}</dt>
              <dd>{{ cardBlngDl.mskngCrdNo }}</dd>
            </dl>
            <dd class="mgt20">
              <button class="small bt-white"
                      style="width: 100%"
                      @click="btnCardBlngDlt_click(cardBlngDl.bcrtnoMngSn, cardBlngDl.bcrtno)"><span>삭제</span></button>
            </dd>
          </div>
          <div class="entry-con" v-else>
            <a href="javascript:;"
               @click="btnCardBlngRgst_click()">
              <dl>
                <dt><i class="fal fa-plus-circle fa-2x"></i></dt>
                <dd>카드를 등록해 주세요.</dd>
              </dl>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <teleport to="body">
    <bill-key-rgst
        ref="billKeyRgstRef"
        @rgst="rgstBillCardResult.rgst"
        @syserr="rgstBillCardResult.syserr" />
  </teleport>
</template>

<script setup>
import {defineProps, onMounted, ref} from "vue";
import {getStore, getUtils} from "@/utils/import";
import BillKeyRgst from "@/components/bill-key-rgst.vue";

const {$axios,  $alert, $confirm, $cmmn} = getUtils();
const {$loading, $mber} = getStore();

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true,
  }
});

const billKeyRgstRef = ref(null);

const cardBlngDl = ref({
  bcrtnoMngSn: null,
  issuCdcoNm: null,
  mskngCrdNo: null,
  bcrtno: null,
});

const getBcrtnoMngDls = async (params) => {
  const { data } = await $axios.get(
      '/api/stlm/bcrtno-mng-dls',
      {params}
  );
  return data;
};

const btnCardBlngRgst_click = async () => {
  try {
    $loading.on();

    await showBillKeyRgst();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
};

const showBillKeyRgst = async () => {
  const params = {mberSn: $mber.mberSn};
  const res = await $axios.get('/api/mber/by-mber-sn', {params});
  const {mberId, mberNm, mbpnTlno, mberEmail} = res.data;
  const {data: svcs} = await $axios.get('/api/svc/svcs');
  const goodsNm = svcs[0].svcNm;

  const rgstParams = {
    goodsNm,
    ordNm: mberNm,
    ordTel: mbpnTlno,
    ordEmail: mberEmail,
    mbsUsrId: mberId,
  };
  billKeyRgstRef.value.show(rgstParams);
};

const rgstBillCardResult = {
  rgst: async (result) => {
    try {
      $loading.on();

      if (result.resultCd == 'F011' || result.resultCd == 'A000') {
        const params = {
          issuCdcoCd: result.issuCdcoCd,
          issuCdcoNm: result.issuCdcoNm,
          mskngCrdNo: result.mskngCrdNo,
          bcrtno: result.bcrtno,
          fcltySn: props.fcltySn,
          mberSn: $mber.mberSn
        };

        const { data: bcrtnoMngSn} = await $axios.post('/api/stlm/bcrtno-mng-dl', params);
        await $alert('결제수단을 등록하였습니다.');

        const fcltySvcUseDl = await getFcltySvcUseDlByFcltySnSvcId(props.fcltySn);
        if (fcltySvcUseDl) {
          const gdsCntrctSn = fcltySvcUseDl.gdsCntrctSn;
          if (gdsCntrctSn) {
            const gdsCntrctDl = await getGdsCntrctDlByGdsCntrctSn(gdsCntrctSn);
            if (gdsCntrctDl && !gdsCntrctDl.bcrtnoMngSn) {
              const msg = '기본서비스에 추가된 결제수단을 등록하시겠습니까?';
              const isConfirm = await $confirm(msg);
              if (!isConfirm) return false;

              await rgstBillCard({bcrtnoMngSn, gdsCntrctSn});
            }
          }
        }
      } else {
        await $alert('결제수단 등록에 실패하였습니다.<br/>( [' + result.resultCd + ']' + result.resultMsg + ' )');
      }

      await init();
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  syserr: async () => {
    await $alert('결제수단 등록에 실패하였습니다. 관리자에게 문의해주세요.');
  },
};

const rgstBillCard = async ({bcrtnoMngSn, gdsCntrctSn}) => {
  await $axios.post('/api/svc/register-gds-cntrct-dl-stlm-mn', {
    gdsCntrctSn,
    bcrtnoMngSn,
    mberSn: $mber.mberSn
  });
  await $alert('정기결제수단을 등록하였습니다.');
};

const getFcltySvcUseDlByFcltySnSvcId = async (fcltySn) => {
  const params = {svcId: $cmmn.svc.getSeroiSvcId(), fcltySn};
  const {data} = await $axios.get('/api/svc/fclty-svc-use-dl/by-fclty-sn-svc-id', {params});
  return data;
};

const getGdsCntrctDlByGdsCntrctSn = async (gdsCntrctSn) => {
  const {data} = await $axios.get(
      '/api/svc/gds-cntrct-dl/by-gds-cntrct-sn',
      {params: {gdsCntrctSn}}
  );
  return data;
};

const getGdsCntrctDlsByBcrtnoMngSn = async (params) => {
  const { data } = await $axios.get('/api/svc/gds-cntrct-dls/by-bcrtno-mng-sn', {params});
  return data;
};

const btnCardBlngDlt_click = async (bcrtnoMngSn, bcrtno) => {
  try {
    $loading.on();

    // 등록된 결제수단 확인
    if (bcrtnoMngSn != null) {
      const cardBlngMngDls = await getGdsCntrctDlsByBcrtnoMngSn({bcrtnoMngSn});
      if (cardBlngMngDls.length > 0) {
        await $alert('서비스신청내역 또는 연말정산신청내역에 등록된 정기결제수단을 먼저 삭제해 주세요.');
        return false;
      }
    }

    const msg = '결제수단을 삭제하시겠습니까?';
    const isConfirm = await $confirm(msg);
    if (!isConfirm) return false;

    const params = {
      bcrtnoMngSn,
      fcltySn: props.fcltySn,
      mberSn: $mber.mberSn
    };

    await $axios.post('/api/stlm/remove-bcrtno-mng-dl', params);
    await $alert('결제수단을 삭제하였습니다.');

    await $axios.post('/onpay/p1/bill/v1/remove', bcrtno,
      {
        headers: { 'Content-Type': 'text/plain' }
      }
    );

    await init();
  } catch (e) {
    await $alert('결제수단 삭제에 실패하였습니다.');
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
};

const init = async () => {
  const [bcrtnoMngDls] = await Promise.all(
      [
        getBcrtnoMngDls({
          fcltySn: props.fcltySn
        }),
      ]
  );

  if (bcrtnoMngDls.length > 0) {
    const bcrtnoMngDl = bcrtnoMngDls[0];
    cardBlngDl.value.bcrtnoMngSn = bcrtnoMngDl.bcrtnoMngSn;
    cardBlngDl.value.issuCdcoNm = bcrtnoMngDl.issuCdcoNm;
    cardBlngDl.value.mskngCrdNo = bcrtnoMngDl.mskngCrdNo;
    cardBlngDl.value.bcrtno = bcrtnoMngDl.bcrtno;
  } else {
    cardBlngDl.value.bcrtnoMngSn = null;
    cardBlngDl.value.issuCdcoNm = null;
    cardBlngDl.value.mskngCrdNo = null;
    cardBlngDl.value.bcrtno = null;
  }

};

const isInit = ref(false);
onMounted(async () => {
  try {
    $loading.on();

    await init();

    isInit.value = true;
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
